import React from 'react'
import { useTranslation } from 'react-i18next';
import '../i18n'; // important to import
const ComparisonTable = () => {
                const { t } = useTranslation('ComparisonTable');
    
    return (
        <>
            <section>
                <div className="pricing-main position-relative">
                    <div className="container">
                        <div className="section-title col-md-12 col-lg-7 m-auto">
                            <span className="d-block">{t("comparisontable")} </span>
                            <h2>{t("findyourperfactfit")} </h2>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-12 col-xl-11">
                                <div className="card border-0">
                                    <div className="card-body px-4 px-lg-5">
                                        <div className="table-responsive table-responsive-xxl pricing-table">
                                            <table className="table align-middle table-sm">
                                                <thead>
                                                    <tr className="border-bottom-0 border-white">
                                                        <th />
                                                        <th> {t("teammastery")} </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <p className="fw-600">{t("courses")} </p>
                                                            <p className="fw-400">
                                                              {t("coursesdes")}
                                                            </p>
                                                        </td>
                                                        <td>
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width={41}
                                                                height={40}
                                                                viewBox="0 0 41 40"
                                                                fill="none"
                                                            >
                                                                <mask
                                                                    id="mask0_257_338"
                                                                    style={{ maskType: "alpha" }}
                                                                    maskUnits="userSpaceOnUse"
                                                                    x={0}
                                                                    y={0}
                                                                    width={41}
                                                                    height={40}
                                                                >
                                                                    <rect
                                                                        x="0.166748"
                                                                        width={40}
                                                                        height={40}
                                                                        fill="#D9D9D9"
                                                                    />
                                                                </mask>
                                                                <g mask="url(#mask0_257_338)">
                                                                    <path
                                                                        d="M16.0835 30.0002L6.5835 20.5002L8.9585 18.1252L16.0835 25.2502L31.3752 9.9585L33.7502 12.3335L16.0835 30.0002Z"
                                                                        fill="#D2E23D"
                                                                    />
                                                                </g>
                                                            </svg>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <p className="fw-600">{t("linkedinachievementbadge")} </p>
                                                            <p className="fw-400">
                                                               {t("linkedinachievementbadgedes")}
                                                            </p>
                                                        </td>
                                                        <td>
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width={41}
                                                                height={40}
                                                                viewBox="0 0 41 40"
                                                                fill="none"
                                                            >
                                                                <mask
                                                                    id="mask0_257_338"
                                                                    style={{ maskType: "alpha" }}
                                                                    maskUnits="userSpaceOnUse"
                                                                    x={0}
                                                                    y={0}
                                                                    width={41}
                                                                    height={40}
                                                                >
                                                                    <rect
                                                                        x="0.166748"
                                                                        width={40}
                                                                        height={40}
                                                                        fill="#D9D9D9"
                                                                    />
                                                                </mask>
                                                                <g mask="url(#mask0_257_338)">
                                                                    <path
                                                                        d="M16.0835 30.0002L6.5835 20.5002L8.9585 18.1252L16.0835 25.2502L31.3752 9.9585L33.7502 12.3335L16.0835 30.0002Z"
                                                                        fill="#D2E23D"
                                                                    />
                                                                </g>
                                                            </svg>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <p className="fw-600">
                                                               {t("complianceexcellencecertificate")}
                                                            </p>
                                                            <p className="fw-400">
                                                                {t("complianceexcellencecertificatedes")}
                                                            </p>
                                                        </td>
                                                        <td>
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width={41}
                                                                height={40}
                                                                viewBox="0 0 41 40"
                                                                fill="none"
                                                            >
                                                                <mask
                                                                    id="mask0_257_338"
                                                                    style={{ maskType: "alpha" }}
                                                                    maskUnits="userSpaceOnUse"
                                                                    x={0}
                                                                    y={0}
                                                                    width={41}
                                                                    height={40}
                                                                >
                                                                    <rect
                                                                        x="0.166748"
                                                                        width={40}
                                                                        height={40}
                                                                        fill="#D9D9D9"
                                                                    />
                                                                </mask>
                                                                <g mask="url(#mask0_257_338)">
                                                                    <path
                                                                        d="M16.0835 30.0002L6.5835 20.5002L8.9585 18.1252L16.0835 25.2502L31.3752 9.9585L33.7502 12.3335L16.0835 30.0002Z"
                                                                        fill="#D2E23D"
                                                                    />
                                                                </g>
                                                            </svg>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <p className="fw-600">{t("silvercourses")} </p>
                                                            <p className="fw-400">
                                                               {t("silvercoursesdes")}
                                                            </p>
                                                        </td>
                                                        <td>
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width={41}
                                                                height={40}
                                                                viewBox="0 0 41 40"
                                                                fill="none"
                                                            >
                                                                <mask
                                                                    id="mask0_257_338"
                                                                    style={{ maskType: "alpha" }}
                                                                    maskUnits="userSpaceOnUse"
                                                                    x={0}
                                                                    y={0}
                                                                    width={41}
                                                                    height={40}
                                                                >
                                                                    <rect
                                                                        x="0.166748"
                                                                        width={40}
                                                                        height={40}
                                                                        fill="#D9D9D9"
                                                                    />
                                                                </mask>
                                                                <g mask="url(#mask0_257_338)">
                                                                    <path
                                                                        d="M16.0835 30.0002L6.5835 20.5002L8.9585 18.1252L16.0835 25.2502L31.3752 9.9585L33.7502 12.3335L16.0835 30.0002Z"
                                                                        fill="#D2E23D"
                                                                    />
                                                                </g>
                                                            </svg>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <p className="fw-600">{t("goldcourses")} </p>
                                                            <p className="fw-400">
                                                                {t("goldcoursesdes")}
                                                            </p>
                                                        </td>
                                                        <td>
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width={41}
                                                                height={40}
                                                                viewBox="0 0 41 40"
                                                                fill="none"
                                                            >
                                                                <mask
                                                                    id="mask0_257_338"
                                                                    style={{ maskType: "alpha" }}
                                                                    maskUnits="userSpaceOnUse"
                                                                    x={0}
                                                                    y={0}
                                                                    width={41}
                                                                    height={40}
                                                                >
                                                                    <rect
                                                                        x="0.166748"
                                                                        width={40}
                                                                        height={40}
                                                                        fill="#D9D9D9"
                                                                    />
                                                                </mask>
                                                                <g mask="url(#mask0_257_338)">
                                                                    <path
                                                                        d="M16.0835 30.0002L6.5835 20.5002L8.9585 18.1252L16.0835 25.2502L31.3752 9.9585L33.7502 12.3335L16.0835 30.0002Z"
                                                                        fill="#D2E23D"
                                                                    />
                                                                </g>
                                                            </svg>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <p className="fw-600">{t("leaderboardandanalytics")} </p>
                                                            <p className="fw-400">
                                                                {t("leaderboardandanalyticsdes")}
                                                            </p>
                                                        </td>
                                                        <td>
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width={41}
                                                                height={40}
                                                                viewBox="0 0 41 40"
                                                                fill="none"
                                                            >
                                                                <mask
                                                                    id="mask0_257_338"
                                                                    style={{ maskType: "alpha" }}
                                                                    maskUnits="userSpaceOnUse"
                                                                    x={0}
                                                                    y={0}
                                                                    width={41}
                                                                    height={40}
                                                                >
                                                                    <rect
                                                                        x="0.166748"
                                                                        width={40}
                                                                        height={40}
                                                                        fill="#D9D9D9"
                                                                    />
                                                                </mask>
                                                                <g mask="url(#mask0_257_338)">
                                                                    <path
                                                                        d="M16.0835 30.0002L6.5835 20.5002L8.9585 18.1252L16.0835 25.2502L31.3752 9.9585L33.7502 12.3335L16.0835 30.0002Z"
                                                                        fill="#D2E23D"
                                                                    />
                                                                </g>
                                                            </svg>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <p className="fw-600">
                                                                {t("allowaccesstomultipleusers")}
                                                            </p>
                                                            <p className="fw-400">
                                                               {t("allowaccesstomultipleusersdes")}
                                                            </p>
                                                        </td>
                                                        <td>
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width={41}
                                                                height={40}
                                                                viewBox="0 0 41 40"
                                                                fill="none"
                                                            >
                                                                <mask
                                                                    id="mask0_257_338"
                                                                    style={{ maskType: "alpha" }}
                                                                    maskUnits="userSpaceOnUse"
                                                                    x={0}
                                                                    y={0}
                                                                    width={41}
                                                                    height={40}
                                                                >
                                                                    <rect
                                                                        x="0.166748"
                                                                        width={40}
                                                                        height={40}
                                                                        fill="#D9D9D9"
                                                                    />
                                                                </mask>
                                                                <g mask="url(#mask0_257_338)">
                                                                    <path
                                                                        d="M16.0835 30.0002L6.5835 20.5002L8.9585 18.1252L16.0835 25.2502L31.3752 9.9585L33.7502 12.3335L16.0835 30.0002Z"
                                                                        fill="#D2E23D"
                                                                    />
                                                                </g>
                                                            </svg>
                                                        </td>
                                                    </tr>
                                                    <tr className="border-bottom-0 border-white">
                                                        <td />
                                                        <td>
                                                            <button
                                                                type="button"
                                                                className="btn-primary rounded-2"
                                                            >
                                                                {t("getonemonthfreeaccess")}
                                                            </button>
                                                            <p className="text-primary text-center mt-3">
                                                                {t("starting1permonthuser")}
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ComparisonTable